import { types } from 'src/store/feature-flags/feature-flags.types';

export const featureFlagsRequest = () => ({
    type: types.FEATURE_FLAGS_REQUEST,
});

export const featureFlagsRefreshRequest = () => ({
    type: types.FEATURE_FLAGS_REFRESH_REQUEST,
});

/**
 * @param {Record<string, boolean>} values - Internal feature flag keys → enabled
 */
export const featureFlagsSuccess = (values) => ({
    type: types.FEATURE_FLAGS_SUCCESS,
    payload: values,
});

export const featureFlagsError = (error) => ({
    type: types.FEATURE_FLAGS_ERROR,
    payload: error,
});

export const clearFeatureFlags = () => ({
    type: types.CLEAR_FEATURE_FLAGS,
});
